import Plugin from "@ckeditor/ckeditor5-core/src/plugin";
import InsertComment from "./insertcomment";

export default class CommentEditing extends Plugin {
  init() {
    this._defineConverters();
    this.editor.commands.add( 'insertComment', new InsertComment( this.editor ) );
  }
  _defineConverters() {
    this.editor.conversion.for("upcast").dataToMarker({
      view: "comment",
      model: (name, conversionApi) => "comment:" + name,
      converterPriority: "high",
    }),
      this.editor.conversion.for("downcast").markerToHighlight({
        model: "comment",
        view: ({ markerName: t }) => ({
          classes: "comment",
          attributes: {
            "data-marker": t.split(":")[1],
            "data-comment-id": t.split(":")[2],
            "data-element": "ef.widget.comment-span",
          },
        }),
        converterPriority: "high",
      }),
      this.editor.conversion.for("dataDowncast").markerToData({
        model: "comment",
        view: (markerName) => ({
          group: "comment",
          name: markerName.substr(8),
        }),
        converterPriority: "high",
      });
  }
}
